import getRendererClass from './GridRendererClass';

const formatDate = value => {
  if (!value) return '';
  const date = new Date(value);
  const formattedDate = date.toLocaleDateString('ko-KR', {
    year: '2-digit',
    month: '2-digit',
    day: '2-digit',
  });
  const formattedTime = date.toLocaleTimeString('ko-KR', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
  return `${formattedDate
    .replace(/\./g, '/')
    .replace(/ /g, '')
    .replace(/\/$/, '')} ${formattedTime}`;
};

const formatDateYYYYMMDD = value => {
  if (!value) return '';
  const year = value.substring(0, 4);
  const month = value.substring(4, 6);
  const day = value.substring(6, 8);
  return `${year}/${month}/${day}`;
};

const addOneYear = value => {
  if (!value) return '';
  const year = parseInt(value.substring(0, 4), 10);
  const month = parseInt(value.substring(4, 6), 10) - 1;
  const day = parseInt(value.substring(6, 8), 10);
  const date = new Date(year, month, day);
  date.setFullYear(date.getFullYear() + 1);
  const newYear = date.getFullYear();
  const newMonth = String(date.getMonth() + 1).padStart(2, '0');
  const newDay = String(date.getDate()).padStart(2, '0');
  return `${newYear}/${newMonth}/${newDay}`;
};

const getScoreColor = (type, mode = 'ai', value) => {
  if (!value) return null;

  if (mode === 'ai') {
    if (type === 'OWAS') {
      switch (value) {
        case 1:
          return '#28a745';
        case 2:
          return '#fff700';
        case 3:
          return '#ffa600';
        default:
          return '#ffa600';
      }
    } else if (type === 'RULA') {
      switch (value) {
        case 1:
        case 2:
          return '#28a745';
        case 3:
        case 4:
          return '#fff700';
        case 5:
        case 6:
          return '#ffa600';
        default:
          return '#ffa600';
      }
    } else if (type === 'REBA') {
      switch (value) {
        case 1:
          return '#28a745';
        case 2:
        case 3:
          return '#fff700';
        case 4:
        case 5:
        case 6:
        case 7:
          return '#fff700';
        case 8:
        case 9:
        case 10:
          return '#ffa600';
        default:
          return '#ffa600';
      }
    }
  } else if (mode === 'expt') {
    if (type === 'OWAS') {
      switch (value) {
        case 1:
          return '#28a745';
        case 2:
          return '#ffa600';
        case 3:
          return '#ff4200';
        default:
          return '#dc3545';
      }
    } else if (type === 'RULA') {
      switch (value) {
        case 1:
        case 2:
          return '#28a745';
        case 3:
        case 4:
          return '#fff700';
        case 5:
        case 6:
          return '#ffa600';
        default:
          return '#dc3545';
      }
    } else if (type === 'REBA') {
      switch (value) {
        case 1:
          return '#28a745';
        case 2:
        case 3:
          return '#fff700';
        case 4:
        case 5:
        case 6:
        case 7:
          return '#ffa600';
        case 8:
        case 9:
        case 10:
          return '#ff4200';
        default:
          return '#dc3545';
      }
    }
  }
};

const member_userList = [
  {
    header: '선택',
    name: 'selected',
    editor: 'text',
  },
  {
    header: '회원아이디',
    name: 'userId',
    editor: 'text',
  },
  {
    header: '이름',
    name: 'userNm',
    editor: 'text',
  },
  {
    header: '전화번호',
    name: 'userTelno',
    editor: 'text',
  },
  {
    header: '휴대전화',
    name: 'userMblTelno',
    editor: 'text',
  },
  {
    header: '이메일주소',
    name: 'userEml',
    editor: 'text',
  },
  {
    header: '소속기업명',
    name: 'entNm',
    editor: 'text',
  },
  {
    header: '소속기업 사업자등록번호',
    name: 'brno',
    editor: 'text',
  },
  {
    header: '계정 활성화',
    name: 'activateAccount',
    // editor: 'button',
  },
  {
    header: '패스워드 초기화',
    name: 'resetPassword',
    // editor: 'button',
  },
];

const expertAnalyzeList = [
  {
    header: 'NO',
    name: 'no',
    type: 'text',
    align: 'center',
    width: '10',
  },
  {
    header: '기업명',
    name: 'entNm',
    type: 'text',
    align: 'center',
    width: '60',
    ellipsis: true,
    whiteSpace: 'nowrap',
    renderer: {
      attributes: {
        title: props => `${props.formattedValue}`,
      },
    },
  },
  {
    header: '업종명',
    name: 'tpbizTypeNm',
    type: 'text',
    align: 'center',
    width: '60',
    ellipsis: true,
    whiteSpace: 'nowrap',
    renderer: {
      attributes: {
        title: props => `${props.formattedValue}`,
      },
    },
  },
  // {
  //   header: '요청자',
  //   name: 'userNm',
  //   type: 'text',
  //   align: 'center',
  //   width: '60',
  //   ellipsis: true,
  //   whiteSpace: 'nowrap',
  //   renderer: {
  //     attributes: {
  //       title: props => `${props.formattedValue}`,
  //     },
  //   },
  // },
  {
    header: '공정명',
    name: 'taskNm',
    type: 'text',
    align: 'center',
    width: '100',
    ellipsis: true,
    whiteSpace: 'nowrap',
    renderer: {
      attributes: {
        title: props => `${props.formattedValue}`,
      },
    },
  },
  {
    header: '작업명',
    name: 'workNm',
    type: 'text',
    align: 'center',
    width: '100',
    ellipsis: true,
    whiteSpace: 'nowrap',
    renderer: {
      attributes: {
        title: props => `${props.formattedValue}`,
      },
    },
  },
  // {
  //   header: '전문가',
  //   name: 'exprtNm',
  //   type: 'text',
  //   align: 'center',
  //   width: '60',
  //   ellipsis: true,
  //   whiteSpace: 'nowrap',
  //   renderer: {
  //     attributes: {
  //       title: props => `${props.formattedValue}`,
  //     },
  //   },
  // },
  {
    header: '조사일자',
    name: 'regDt',
    type: 'text',
    align: 'center',
    width: '100',
  },
  // {
  //   header: '요청일자',
  //   name: 'anlsDmndDt',
  //   type: 'text',
  //   align: 'center',
  //   width: '100',
  // },
  // {
  //   header: '시작일자',
  //   name: 'anlsBgngDt',
  //   type: 'text',
  //   align: 'center',
  //   width: '100',
  // },
  // {
  //   header: '완료일자',
  //   name: 'anlsCmptnDt',
  //   type: 'text',
  //   align: 'center',
  //   width: '100',
  // },
  {
    header: 'OWAS',
    name: 'aiOwas',
    type: 'text',
    align: 'center',
    width: '60',
    formatter: v => (v.row.aiOwas ? 'AC' + v.row.aiOwas : null),
    renderer: {
      styles: {
        backgroundColor: props => getScoreColor('OWAS', 'ai', props.value),
      },
    },
  },
  {
    header: 'RULA',
    name: 'aiRula',
    type: 'text',
    align: 'center',
    width: '60',
    renderer: {
      styles: {
        backgroundColor: props => getScoreColor('RULA', 'ai', props.value),
      },
    },
  },
  {
    header: 'REBA',
    name: 'aiReba',
    type: 'text',
    align: 'center',
    width: '60',
    renderer: {
      styles: {
        backgroundColor: props => getScoreColor('REBA', 'ai', props.value),
      },
    },
  },
  {
    header: 'OWAS',
    name: 'exprtOwas',
    type: 'text',
    align: 'center',
    width: '60',
    formatter: v => (v.row.exprtOwas ? 'AC' + v.row.exprtOwas : null),
    renderer: {
      styles: {
        backgroundColor: props => getScoreColor('OWAS', 'expt', props.value),
      },
    },
  },
  {
    header: 'RULA',
    name: 'exprtRula',
    type: 'text',
    align: 'center',
    width: '60',
    renderer: {
      styles: {
        backgroundColor: props => getScoreColor('RULA', 'expt', props.value),
      },
    },
  },
  {
    header: 'REBA',
    name: 'exprtReba',
    type: 'text',
    align: 'center',
    width: '60',
    renderer: {
      styles: {
        backgroundColor: props => getScoreColor('REBA', 'expt', props.value),
      },
    },
  },
  {
    header: '상태',
    name: 'status',
    type: 'text',
    align: 'center',
    width: '90',
    renderer: {
      type: getRendererClass('expertAnalyzeStatus'),
    },
  },
];

const analyzeReportWrite = [
  {
    header: '단위작업명',
    name: 'job1',
    type: 'text',
    align: 'center',
  },
  {
    header: '부담작업(호)',
    name: 'job2',
    type: 'text',
    align: 'center',
  },
  {
    header: '작업부하(A)',
    name: 'workLoad',
    type: 'text',
    align: 'center',
  },
  {
    header: '작업빈도(B)',
    name: 'workFreq',
    type: 'text',
    align: 'center',
  },
  {
    header: '총점수(A*B)',
    name: 'totalScore',
    type: 'text',
    align: 'center',
    formatter: v => v.row.workLoad * v.row.workFreq,
  },
];

const analyzeReportWriteDetail = [
  {
    header: '유해요인',
    name: 'rskVrbl',
    type: 'text',
    align: 'center',
  },
  {
    header: '발생원인',
    name: 'rskVrblCs',
    type: 'text',
    align: 'center',
  },
  {
    header: '비고',
    name: 'etc',
    type: 'text',
    align: 'center',
  },
];

const cnslt_aplyList_exprt = [
  {
    header: 'NO',
    name: 'totalSeq',
    type: 'text',
    align: 'center',
  },
  {
    header: '기업명',
    name: 'entNm',
    type: 'text',
    align: 'center',
    ellipsis: true,
    whiteSpace: 'nowrap',
    renderer: {
      attributes: {
        title: props => `${props.formattedValue}`,
      },
    },
  },
  {
    header: '업종명',
    name: 'tpbizTypeNm',
    type: 'text',
    align: 'center',
    ellipsis: true,
    whiteSpace: 'nowrap',
    renderer: {
      attributes: {
        title: props => `${props.formattedValue}`,
      },
    },
  },
  {
    header: '요청자',
    name: 'userNm',
    type: 'text',
    align: 'center',
    ellipsis: true,
    whiteSpace: 'nowrap',
    renderer: {
      attributes: {
        title: props => `${props.formattedValue}`,
      },
    },
  },
  {
    header: '공정명',
    name: 'taskNm',
    type: 'text',
    align: 'center',
    ellipsis: true,
    whiteSpace: 'nowrap',
    renderer: {
      attributes: {
        title: props => `${props.formattedValue}`,
      },
    },
  },
  // {
  //   header: '전문가',
  //   name: 'exprtNm',
  //   type: 'text',
  //   align: 'center',
  // },
  {
    header: '요청일자',
    name: 'cnsltDmndDt',
    type: 'text',
    align: 'center',
  },
  {
    header: '시작일자',
    name: 'cnsltAprvDt',
    type: 'text',
    align: 'center',
  },
  {
    header: '완료일자',
    name: 'cnsltDt',
    type: 'text',
    align: 'center',
  },
  {
    header: '상태',
    name: 'cnsltSttsNm',
    align: 'center',
    renderer: {
      type: getRendererClass('ExpertConsultGridButton'),
    },
  },
];

const cnslt_aplyList_user = [
  {
    header: 'NO',
    name: 'totalSeq',
    type: 'text',
    align: 'center',
  },
  // {
  //   header: '기업명',
  //   name: 'entNm',
  //   type: 'text',
  //   align: 'center',
  // },
  // {
  //   header: '업종명',
  //   name: 'tpbizTypeNm',
  //   type: 'text',
  //   align: 'center',
  // },
  {
    header: '요청자',
    name: 'userNm',
    type: 'text',
    align: 'center',
    ellipsis: true,
    whiteSpace: 'nowrap',
    renderer: {
      attributes: {
        title: props => `${props.formattedValue}`,
      },
    },
  },
  {
    header: '공정명',
    name: 'taskNm',
    type: 'text',
    align: 'center',
    ellipsis: true,
    whiteSpace: 'nowrap',
    renderer: {
      attributes: {
        title: props => `${props.formattedValue}`,
      },
    },
  },
  {
    header: '전문가',
    name: 'exprtNm',
    type: 'text',
    align: 'center',
    ellipsis: true,
    whiteSpace: 'nowrap',
    renderer: {
      attributes: {
        title: props => `${props.formattedValue}`,
      },
    },
  },
  {
    header: '요청일자',
    name: 'cnsltDmndDt',
    type: 'text',
    align: 'center',
  },
  {
    header: '시작일자',
    name: 'cnsltAprvDt',
    type: 'text',
    align: 'center',
  },
  {
    header: '완료일자',
    name: 'cnsltDt',
    type: 'text',
    align: 'center',
  },
  {
    header: '상태',
    name: 'cnsltSttsNm',
    align: 'center',
    renderer: {
      type: getRendererClass('ExpertConsultGridButton2'),
    },
  },
];

const expertAuditList = [
  {
    header: 'NO',
    name: 'no',
    type: 'text',
    align: 'center',
    width: '10',
  },
  {
    header: '소속명',
    name: 'entNm',
    type: 'text',
    align: 'center',
    width: '200',
    ellipsis: true,
    whiteSpace: 'nowrap',
    renderer: {
      attributes: {
        title: props => `${props.formattedValue}`,
      },
    },
  },
  {
    header: '요청자',
    name: 'userNm',
    type: 'text',
    align: 'center',
    width: '90',
    ellipsis: true,
    whiteSpace: 'nowrap',
    renderer: {
      attributes: {
        title: props => `${props.formattedValue}`,
      },
    },
  },
  {
    header: '요청일자',
    name: 'aplyDt',
    type: 'text',
    align: 'center',
    width: '120',
  },
  {
    header: '심사종료일자',
    name: 'srngCmptnDt',
    type: 'text',
    align: 'center',
    width: '120',
  },
  {
    header: '상태',
    name: 'srngRsltCd',
    type: 'text',
    align: 'center',
    renderer: {
      type: getRendererClass('ExpertAuditStatus'),
    },
    width: '10',
  },
];

const workerInfo = [
  {
    header: '근로자명',
    name: 'wrkrNm',
    type: 'text',
  },
  {
    header: '직책',
    name: 'wrkrRole',
    type: 'text',
  },
  {
    header: '휴대전화번호',
    name: 'wrkrMblTelno',
    type: 'text',
  },
  {
    header: '작업부서',
    name: 'wrkrDept',
    type: 'text',
  },
  {
    header: '발송일시',
    name: 'sndngDt',
    type: 'text',
    formatter: ({ value }) => formatDate(value),
  },
  {
    header: '회신여부',
    name: 'userRplYn',
    align: 'center',
    type: 'text',
  },
  {
    header: '회신일시',
    name: 'userRplDt',
    type: 'text',
    formatter: ({ value }) => formatDate(value),
  },
];

const taskInfo = [
  {
    header: '선택',
    name: 'selected',
    align: 'center',
    renderer: {
      type: getRendererClass('checkBox'),
    },
  },
  {
    header: '업종',
    name: 'tpbizTypeNm',
    type: 'text',
  },
  {
    header: '공정명',
    name: 'comCdNm',
    type: 'text',
  },
  {
    header: '등록일자',
    name: 'regDt',
    type: 'text',
    formatter: ({ value }) => formatDate(value),
  },
  {
    header: '이전조사일자',
    name: 'aplyYmd',
    type: 'text',
    formatter: ({ value }) => formatDateYYYYMMDD(value),
  },
  {
    header: '다음조사일자',
    name: 'nextRsrchDt',
    type: 'text',
    formatter: ({ row }) => addOneYear(row.aplyYmd),
  },
  {
    header: '조사시작',
    name: 'rsrchBgng',
    type: 'text',
  },
];

export default function getGridColumns(id) {
  switch (id) {
    case 'member_userList':
      return member_userList;
    case 'expertAnalyzeList':
      return expertAnalyzeList;
    case 'cnslt_aplyList_user':
      return cnslt_aplyList_user;
    case 'cnslt_aplyList_exprt':
      return cnslt_aplyList_exprt;
    case 'expertAuditList':
      return expertAuditList;
    case 'workerInfo':
      return workerInfo;
    case 'taskInfo':
      return taskInfo;
  }

  /* 보고서 생성 영역으로 인하여 id 중복문제가 발생하여 수정 */
  if (id.startsWith('analyzeReportWriteDetail')) {
    return analyzeReportWriteDetail;
  } else if (id.startsWith('analyzeReportWrite')) {
    return analyzeReportWrite;
  }
}
